var __rest = this && this.__rest || function (s, e) {
  var t = {};
  for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0) t[p] = s[p];
  if (s != null && typeof Object.getOwnPropertySymbols === "function") for (var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++) {
    if (e.indexOf(p[i]) < 0 && Object.prototype.propertyIsEnumerable.call(s, p[i])) t[p[i]] = s[p[i]];
  }
  return t;
};
import * as React from 'react';
const SvgTag = _a => {
  var _b, _c;
  var {
      size
    } = _a,
    props = __rest(_a, ["size"]);
  return React.createElement("svg", Object.assign({
    xmlns: "http://www.w3.org/2000/svg",
    width: size !== null && size !== void 0 ? size : 24,
    height: size !== null && size !== void 0 ? size : 24,
    viewBox: "0 0 24 24",
    role: props.role,
    "aria-hidden": (_b = props['aria-hidden']) !== null && _b !== void 0 ? _b : true
  }, props), React.createElement("path", {
    fill: (_c = props.color) !== null && _c !== void 0 ? _c : 'currentColor',
    fillRule: "evenodd",
    d: "M22.1219055,14.93875 L14.950625,22.110035 C14.4348123,22.6264219 13.7348754,22.9165733 13.005,22.9165733 C12.2751246,22.9165733 11.5751877,22.6264219 11.0599789,22.1106389 L2.46997887,13.5306389 C2.3291376,13.3899616 2.25,13.1990637 2.25,13 L2.25,3 C2.25,2.58578644 2.58578644,2.25 3,2.25 L13,2.25 C13.1989124,2.25 13.3896778,2.32901763 13.5303301,2.46966991 L22.1219055,11.06125 C23.1881454,12.133853 23.1881454,13.866147 22.1219055,14.93875 Z M3.75,12.6890839 L12.120625,21.049965 C12.3550853,21.2846863 12.6732384,21.4165733 13.005,21.4165733 C13.3367616,21.4165733 13.6549147,21.2846863 13.8896699,21.0496699 L21.0596699,13.8796699 C21.542749,13.3937032 21.542749,12.6062968 21.0596699,12.1203301 L12.6893398,3.75 L3.75,3.75 L3.75,12.6890839 Z M8,9 C7.44771525,9 7,8.55228475 7,8 C7,7.44771525 7.44771525,7 8,7 C8.55228475,7 9,7.44771525 9,8 C9,8.55228475 8.55228475,9 8,9 Z"
  }));
};
export default SvgTag;